<template>
  <div class="foot">
    <div class="footer">
      <div class="footer_title">每人纪</div>
      <div class="footer_line"></div>
      <div class="footer_right">
        <div class="footer_right_title">快捷导航</div>
        <div class="footer_right_content" @click="navto(0)">首页</div>
        <div class="footer_right_content" @click="navto(1)">人才库</div>
        <div class="footer_right_content" @click="navto(2)">作品动态</div>
      </div>      <div class="footer_right">
        <div class="footer_right_title">关于我们</div>
        <div class="footer_right_content" @click="navto(3)">关于我们</div>
        <div class="footer_right_content">加入我们</div>
        <div class="footer_right_content">联系我们</div>
      </div>
      <div class="footer_right">
        <div class="footer_right_title">快捷导航</div>
        <div class="footer_right_content">每人纪小程序</div>
        <div class="footer_right_content">每人纪官网</div>
      </div>
      <img class="footer_img" src="../assets/images/weixin.png">
      <img class="footer_img" src="../assets/images/weibo.png">
    </div>
    <div class="foot_copy">
      <div class="foot_copy_t1">Copyright @ 2025 上海每人纪信息科技有限公司 版权所有</div>
      <div class="foot_copy_t2"><a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow">沪ICP备2024076367号</a></div>
    </div>
  </div>
</template>
<script>
export default{
  name: 'Footer',
  data(){
    return{

    }
  },
  methods:{
    navto(index){
      if(index==0){
        this.$router.push('/index/index')
      }
      else if(index==1){
        this.$router.push('/people/index')
      }
      else if(index==2){
        this.$router.push('/notice/index')
      }
      else if(index==3){
        this.$router.push('/about/index')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.foot{
  margin-top: 100px;
  width: 100%;
  height: 300px;
  background: #282828;
}
.footer{
  padding-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer_title{
  font-family: PingFangSC-Regular;
  font-size: 40px;
  color: #B5B5B6;
  font-weight: 400;
}
.footer_line{
  width: 1px;
  height: 80px;
  margin: 0 80px;
  background-color: #B5B5B6;
}
.footer_right{
  margin-right: 100px;
  height: 140px;
}
.footer_right_title{
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #FFFFFF;
  font-weight: 500;
}
.footer_right_content{
  margin-top: 12px;
  font-family: PingFangSC-Light;
  font-size: 16px;
  color: #B5B5B6;
  font-weight: 200;
}
.footer_right_content:hover{
  text-decoration: underline;
}
.footer_img{
  margin-right: 25px;
  width: 56px;
  height: 56px;
}
.foot_copy{
  margin-top: 10px;
  font-family: PingFangSC-Light;
  font-size: 16px;
  color: #B5B5B6;
  text-align: center;
}
.foot_copy_t2{
  margin-top: 10px;
}
.foot_copy_t2:hover{
  text-decoration: underline;
}
/* 1200-1600 */
@media screen and (max-width:1600px){
}
/* 992-1200 */
@media screen and (max-width: 1200px) {
  .header{
    padding: 0 15%;
  }
}
/* 750-992 */
@media screen and (max-width:992px) {
  .footer{
    margin-top: 60px;
    height: 200px;
  }
  .footer_title{
    font-size: 20px;
  }
  .footer_line{
    height: 80px;
    margin: 0 30px;
  }
  .footer_right{
    margin-right: 40px;
    height: 80px;
  }
  .footer_right_title{
    font-size: 12px;
  }
  .footer_right_content{
    margin-top: 6px;
    font-size: 12px;
  }
  .footer_img{
    margin-right: 10px;
    width: 40px;
    height: 40px;
  }
  .foot_copy{
    font-size: 12px;
  }
}
/* 375-750 */
@media screen and (max-width:750px) {
  .footer{
    margin-top: 60px;
    height: 200px;
  }
  .footer_title{
    font-size: 18px;
  }
  .footer_line{
    height: 80px;
    margin: 0 10px;
  }
  .footer_right{
    margin-right: 20px;
    height: 80px;
  }
  .footer_right_title{
    font-size: 12px;
  }
  .footer_right_content{
    margin-top: 6px;
    font-size: 12px;
  }
  .footer_img{
    margin-right: 10px;
    width: 20px;
    height: 20px;
  }
  .foot_copy{
    font-size: 12px;
  }
}
</style>